import React from "react";

const ToolbarSpacer = _props => <div className="toolbarSpacer" />;

ToolbarSpacer.propTypes = {};

export default ToolbarSpacer;
